import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './List';
import Session from './Session';
import store from '../../store';
import './style.scss';

export const PLENARY = 'plenary';
export const COMMITTEE = 'committee';

export const Voting = () => {
	const rootPath = '/admin';
	return <Switch>
		<Route exact path={`/admin/voting/`} component={() => <List rootPath={rootPath} />} />
		<Route exact path={`/admin/voting/:id`} component={() => <Session rootPath={rootPath} />} />
	</Switch>;
};

export { default as createVotingForSession } from './helpers/createVotingForSession';
export { default as canCreateVotingForSession } from './helpers/canCreateVotingForSession';
export { default as getSourceSessionParams } from './helpers/getSourceSessionParams';
export { default as getQuestions } from './helpers/getQuestions';

export { default as getPlenaryQuestions } from './helpers/getPlenaryQuestions';
export { default as getPlenaryQuestionData } from './helpers/getPlenaryQuestionData';

export { default as getCommitteeQuestions } from './helpers/getCommitteeQuestions';
export { default as getCommitteeQuestionData } from './helpers/getCommitteeQuestionData';
